import {
  type FormContext,
  type GenericObject,
  type TypedSchema,
  useForm,
  useIsSubmitting
} from 'vee-validate';
import { watch } from 'vue';

import { ERROR_SCROLL_AREA_CLASS } from '@/constants/common.const';
import type { VeeValidateFormOptions, VeeValidateFormSchema } from '@/types/validation.type';

export const useVeeValidate = <
  TValues extends GenericObject = GenericObject,
  TOutput = TValues,
  TSchema extends VeeValidateFormSchema<TValues> | TypedSchema<TValues, TOutput> =
    | VeeValidateFormSchema<TValues>
    | TypedSchema<TValues, TOutput>
>(
    opts?: VeeValidateFormOptions<TValues, TOutput, TSchema>
  ): FormContext<TValues, TOutput> => {
  const form = useForm(opts);
  const isSubmitting = useIsSubmitting();
  watch(
    () => isSubmitting.value,
    (submitting: boolean) => {
      if (submitting) {
        setTimeout(() => {
          const elms = document.getElementsByClassName(ERROR_SCROLL_AREA_CLASS);
          for (const elm of elms) {
            const errorMsgElm = elm.querySelector('.text-error');
            if (errorMsgElm) {
              const foldingContent = elm.closest('.folding-content') as HTMLElement | null;
              if (foldingContent && foldingContent.style.display === 'none') {
                continue;
              }
              elm.scrollIntoView({ behavior: 'smooth', block: 'center' });
              break;
            }
          }
        }, 300);
      }
    }
  );
  return form;
};
